import React from 'react';
import {Body, Button} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './ConfigureBrandModal.module.scss';

interface ConnectedAccountRowProps {
  name: string;
  description: string;
  isConnected: boolean;
  connectedLabel?: string;
  onLink?: () => void;
  onUnlink?: () => void;
  linkLabel?: string;
  linkDisabled?: boolean;
  isLoading?: boolean;
  inputField?: React.ReactNode;
  linkTestId?: string;
  unlinkTestId?: string;
  confirmationTestId?: string;
}

function ConnectedAccountRow({
  name,
  description,
  isConnected,
  connectedLabel,
  onLink,
  onUnlink,
  linkLabel,
  linkDisabled,
  isLoading,
  inputField,
  linkTestId,
  unlinkTestId,
  confirmationTestId,
}: ConnectedAccountRowProps) {
  return (
    <div className={styles.accountRow}>
      <div className={styles.accountHeader}>
        <div className={styles.accountInfo}>
          <Body size="md" className={styles.accountName}>
            {name}
          </Body>
          <Body size="sm" className={styles.accountDescription}>
            {description}
          </Body>
        </div>

        {isConnected && (
          <div className={styles.connectedState}>
            <span
              {...(confirmationTestId
                ? {[`data-test-${confirmationTestId}`]: true}
                : {})}
            >
              {translate('{name} connected', {
                name: connectedLabel || name,
              })}
            </span>
            <Button
              appearance="neutral"
              mode="plain"
              size="small"
              onClick={onUnlink}
              {...(unlinkTestId ? {[`data-test-${unlinkTestId}`]: true} : {})}
            >
              {translate('Unlink')}
            </Button>
          </div>
        )}
        {!isConnected && !inputField && (
          <Button
            appearance="neutral"
            mode="filled"
            size="small"
            onClick={onLink}
            disabled={linkDisabled || isLoading}
            {...(linkTestId ? {[`data-test-${linkTestId}`]: true} : {})}
          >
            {linkLabel || translate('Link')}
          </Button>
        )}
      </div>

      {!isConnected && inputField && (
        <div className={styles.inputRow}>
          {inputField}
          <Button
            appearance="neutral"
            mode="filled"
            size="small"
            onClick={onLink}
            disabled={linkDisabled || isLoading}
            {...(linkTestId ? {[`data-test-${linkTestId}`]: true} : {})}
          >
            {linkLabel || translate('Link')}
          </Button>
        </div>
      )}
    </div>
  );
}

export default ConnectedAccountRow;
